import { useState, useEffect } from "react";

export function useDarkMode() {
  const [mode, setMode] = useState(
    () => localStorage.getItem('pps_mode') || 'light'
  );
  useEffect(() => {
    document.documentElement.setAttribute('data-mode', mode);
    localStorage.setItem('pps_mode', mode);
  }, [mode]);
  const toggle = () => setMode(m => m === 'light' ? 'dark' : 'light');
  return { mode, toggle };
}
